import { useEffect, useState } from 'react'
import {
  fetchCaptchaConfig,
  type CaptchaPublicConfig,
} from '@/lib/captcha'
import { mergeCaptchaWidgetDefaults } from '@/constants/captcha'

type CaptchaConfigState = {
  config: CaptchaPublicConfig | null
  loaded: boolean
  fetchFailed: boolean
}

const listeners = new Set<(state: CaptchaConfigState) => void>()
let sharedState: CaptchaConfigState = { config: null, loaded: false, fetchFailed: false }
let loadPromise: Promise<CaptchaPublicConfig> | null = null

function notify() {
  for (const listener of listeners) {
    listener(sharedState)
  }
}

function ensureCaptchaConfigLoaded(): Promise<CaptchaPublicConfig> {
  if (loadPromise) {
    return loadPromise
  }

  loadPromise = fetchCaptchaConfig().then(({ config, fetchFailed }) => {
    const merged = mergeCaptchaWidgetDefaults(config)
    sharedState = { config: merged, loaded: true, fetchFailed }
    notify()
    return merged
  })

  return loadPromise
}

export function useCaptchaConfig(): CaptchaConfigState {
  const [state, setState] = useState(sharedState)

  useEffect(() => {
    listeners.add(setState)
    void ensureCaptchaConfigLoaded()
    return () => {
      listeners.delete(setState)
    }
  }, [])

  return state
}
